import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiClientConstant } from '@cureskin/api-client';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';

export interface CheckoutRoutingResolution {
  skip: boolean;
  hasDefaultAddress: boolean;
}

export async function resolveCheckoutRouting(
  route: ActivatedRouteSnapshot,
  conn: ConnectionService,
  experimentService: ExperimentService,
): Promise<CheckoutRoutingResolution> {
  const { type, regimenId } = route.queryParams;
  const isRegimenOrder = type === ApiClientConstant.Order.Type.REGIMEN;
  const isExperimentEnabled = !!experimentService.reviewOrderPageExperiment?.enable;

  if (!isExperimentEnabled || !isRegimenOrder || !regimenId) {
    return { skip: true, hasDefaultAddress: false };
  }

  try {
    const address = await conn.fetchDefaultAddress(conn.getActingUser());
    return { skip: false, hasDefaultAddress: !!address };
  } catch {
    return { skip: false, hasDefaultAddress: false };
  }
}
